import React, { HTMLAttributes } from "react";

import { animated, useInView } from "react-spring";
import WhoIsDesktopSwiper from "./swiperList";

interface IWhoIsSection {}

type TWhoIsSectionProps = IWhoIsSection & HTMLAttributes<HTMLDivElement>;

const WhoIsSection: React.FC<TWhoIsSectionProps> = (props) => {
  // title spring animation
  const [ref, springs] = useInView(() => ({
    from: {
      opacity: 0,
      x: 200,
    },
    to: {
      opacity: 1,
      x: 0,
    },
    config: {
      tension: 150,
      friction: 25,
    },
    rootMargin: "-30%",
    once: false,
  }));

  // cover spring animation
  const [refCover, springsCover] = useInView(() => ({
    from: {
      opacity: 0,
      x: -250,
    },
    to: {
      opacity: 1,
      x: 0,
    },

    rootMargin: "-30%",
    once: false,
  }));

  return (
    <div className="justify-center laptop:items-center flex flex-col p-8 laptop:px-[10%] laptop:flex-row flex-1 gap-6 laptop:gap-10 overflow-hidden">
      <div className="flex flex-col w-full laptop:w-1/2 object-contain self-center">
        {/* mobile title */}
        <animated.h1
          style={springs}
          className="flex flex-col laptop:hidden text-center items-center text-white gap-3"
        >
          <div className="text-4xl">誰是Asgard?</div>
          <span className="text-2xl">Who is Asgard?</span>
        </animated.h1>
        {/* cover */}

        <animated.img
          ref={refCover}
          style={springsCover}
          className="flex rounded-2xl mt-2 laptop:mt-5"
          src={require("../../../assets/images/who_is_cover.png")}
          alt="who_is_cover"
        />
      </div>

      <div className="flex flex-col w-full laptop:w-1/2 gap-3 laptop:gap-8">
        {/* desktop title */}
        <animated.h1
          style={springs}
          className="hidden laptop:flex laptop:flex-row items-baseline text-left text-white gap-3 laptop:gap-1"
        >
          <div className="text-4xl">誰是Asgard? </div>
          <span className="text-2xl"> Who is Asgard?</span>
        </animated.h1>
        <span className="text-sm laptop:text-base text-white laptop:leading-9 font-bold">
          Asgard
          是一家2024年獲香港生產力促進局支持的創科企業提供高效、便捷的電動車充電解決方案。而我們承諾將進一步推動電動車的普及，實現零排放及可持續的目標。
        </span>
        <span
          ref={ref}
          className="text-sm laptop:text-base text-white laptop:leading-8"
        >
          Asgard, a tech startup supported by the Hong Kong Productivity Council
          in 2024, offers efficient, convenient electric vehicle charging
          solutions. We are committed to advancing EV adoption, achieving zero
          emissions, and sustainability goals.
        </span>

        {/* <WhoIsMobileListSection /> */}
        <WhoIsDesktopSwiper />
      </div>
    </div>
  );
};

export default WhoIsSection;
